import React, { useCallback } from 'react';
import AsyncMultiSelect from './AsyncMultiSelect';
import { searchPlaces } from '../api';

export default function PlacesSelect({ label, value, onChange, countries = [], cities = [], max = 50 }) {
  const countryIds = (countries || []).map(c => c.id);
  const cityIds = (cities || []).map(c => c.id);
  const doSearch = useCallback(
    (q, opts) => searchPlaces(q, { countryIds, cityIds, ...opts }),
    [countryIds, cityIds]
  );
  return (
    <AsyncMultiSelect
      label={label}
      placeholder={countries.length || cities.length ? 'Search places' : 'Select countries/cities first'}
      value={value}
      onChange={onChange}
      searchFn={doSearch}
      max={max}
    />
  );
}

